import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE,
} from '@app/components/base/content-structure/cards-grid-config';
import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';
import { ReactNode } from 'react';
import { EditCard } from '../edit-card/EditCard';

export interface VideoEditionsEditGridProps {
  edits: EnrichedVideoEditorEditListItemDto[];
  onCloneEdit: (edit: EnrichedVideoEditorEditListItemDto) => void;
  onEditMutationSuccess?: () => Promise<void> | void;
  renderPublishControl?: (edit: EnrichedVideoEditorEditListItemDto) => ReactNode;
}

/**
 * Responsive grid of edit cards for the video editions tab.
 * Uses the same CardsGrid spacing tokens as fragments/compositions lists.
 */
export function VideoEditionsEditGrid({
  edits,
  onCloneEdit,
  onEditMutationSuccess,
  renderPublishControl,
}: VideoEditionsEditGridProps) {
  return (
    <CardsGrid columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {edits.map((edit) => (
        <CardsGridItem size={CARDS_GRID_ITEM_SIZE} key={edit.id}>
          <EditCard
            edit={edit}
            renderPublishControl={renderPublishControl}
            onClone={() => onCloneEdit(edit)}
            onDeleteSuccess={onEditMutationSuccess}
          />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
